import useCounter from "../../../hooks/useCounter";

const HighlightStat = ({ target, suffix, label }) => {
  const { ref, value } = useCounter(target);

  return (
    <div className="istat">
      <div className="big" ref={ref}>
        {value}
        {suffix}
      </div>
      <div className="l">{label}</div>
    </div>
  );
};

export default HighlightStat;
